import styled from 'styled-components';

export const HtmlStyled = styled.div`
  width: 100%;
  height: 100vh;
  overflow: auto;
  padding: 30px;
  color: #4AF626
  /* display: flex;
  flex-flow: column wrap; */
`;